// Wraps the quasar notifier to make it easier to write unit tests

import { Notify } from 'quasar';
import { FeatureFlags } from 'src/service/FeatureFlags';
import { ref } from 'vue';
import * as Sentry from '@sentry/vue';

type Notification = {
  type: 'Error' | 'Success';
  message: string;
};
const messages: Array<Notification> = [];
const lastError = ref('');

function clearMessages() {
  messages.length = 0;
  lastError.value = '';
}

function notifyError(message: string) {
  if (FeatureFlags.isUnitTest()) {
    messages.push({ type: 'Error', message });
    return;
  }
  lastError.value = message;
  Notify.create({ type: 'negative', message });
}

function notifySuccess(message: string) {
  if (FeatureFlags.isUnitTest()) {
    messages.push({ type: 'Success', message });
    return;
  }
  Notify.create({ type: 'positive', message });
}

function logToSentry(message: string, data?: object) {
  if (FeatureFlags.isUnitTest()) return;

  const extra = data ? ': ' + JSON.stringify(data) : '';
  const exception = new Error(message + extra);
  Sentry.captureException(exception);
}

export function useNotifier() {
  return {
    notifyError,
    notifySuccess,
    messages,
    clearMessages,
    lastError,
    logToSentry,
  };
}
